<div class="slide-toggle"
     style="--onLabel:'{{onLabel}}'; --offLabel:'{{offLabel}}'; --width:{{ width}}">
  <mat-slide-toggle (change)="toggle($event)" [checked]="checked" [disabled]="disabled" [id]='id'>
    <ng-content></ng-content>
  </mat-slide-toggle>
</div>
